import requests from "./httpService";

const EvaluationService = {
  getCalculation(user_id, company_id, manualAssigned, manualCompleted, attributeScores, startDate = "", endDate = "") {
    return requests.get(
      `/evaluation/calculation?user_id=${user_id}&company_id=${company_id}&manualAssigned=${manualAssigned}&manualCompleted=${manualCompleted}&startDate=${startDate}&endDate=${endDate}`
    )
  },

  createevaluation(body) {
    return requests.post(
      `/evaluation/create`, body
    )
  },

  getevaluation(user_id, company_id) {
    return requests.get(
      `/evaluation/get?user_id=${user_id}&company_id=${company_id}`
    )
  },


  getallevaluation(company_id, head_id = "", role = "", viewAll = false) {
    return requests.get(
      `/evaluation/getall?company_id=${company_id}&head_id=${head_id}&role=${role}&viewAll=${viewAll}`
    )
  },


  getPeriodDates(company_id, headId = "") {
    return requests.get(
      `/evaluation/period-dates?company_id=${company_id}&headId=${headId}`
    )
  },

  getPendingEvaluations(headId, companyId) {
    return requests.get(
      `/evaluation/pending-evaluations?headId=${headId}&companyId=${companyId}`
    )
  },

  skipEvaluation(body) {
    return requests.post(
      `/evaluation/skip-evaluation`, body
    )
  },

  calculateAndSave(body) {
    return requests.post(`/evaluation/calculate-and-save`, body);
  },

};

export default EvaluationService;
